import React, { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { isEmpty } from 'lodash';
import { useTranslation } from 'react-i18next';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import BtnAddWithoutToolTip from '../../Components/Utility/FilterAction/BtnAddWIthoutToolTip';
import BtnDelete from '../../Components/Utility/FilterAction/BtnDelete';
import AddEditColumn from './Modals/AddEditColumn';
import * as action from './store/OprationalCP.action';
import MovingColumnCards from './MovingColumnCards';
import { useComponent } from '../UserSetting/UsersLibrary/UserRights';

function ColumnSection({
  isProductArchived,
  addColumn,
  deleteColumn,
  editState,
  handleSelectAllColumns,
  onSelectCheckBox,
  handleEdit,
  closeColumnModal,
  isName,
  setAddEditState,
}) {
  const {
    UserDetails: { isSupplierLoggedIn },
    Users: { logInRights },
  } = useSelector((reducer) => reducer);

  const { CheckActionPermission } = useComponent();
  const dispatch = useDispatch();
  const { t } = useTranslation('common');

  const OperationalAddEditAccess = CheckActionPermission(logInRights, 'criticalPath', 'operational', 'addEdit');
  const OperationalDeleteAccess = CheckActionPermission(logInRights, 'criticalPath', 'operational', 'delete');

  function swapArrayLocs(arr, index1, index2) {
    const temp = arr[index1];
    arr[index1] = arr[index2];
    arr[index2] = temp;
    return arr;
  }

  const moveColumn = async (movedCardIndex, toCardIndex) => {
    const currList = swapArrayLocs(editState.Columns, movedCardIndex, toCardIndex);
    setAddEditState((prevCards) => ({
      ...prevCards,
      Columns: currList,
      isColumnDragging: true,
    }));
  };

  const activeInactiveClicked = async (i) => {
    const currentColumn = [...editState.Columns];
    currentColumn[i].isActive = !currentColumn[i].isActive;
    const insertObj = {
      columns: [{ ...currentColumn[i] }],
      _id: currentColumn[i]?._id,
      fromArchive: true,
      isArchived: currentColumn[i].isActive,
    };
    // columns addUpdateApi
    const res = await dispatch(action.addColumnsToCard(insertObj, t));
    if (res) {
      setAddEditState((oldState) => ({
        ...oldState,
        Columns: currentColumn,
      }));
    }
  };

  const renderTableColumns = useCallback(
    (ColumnItem, ColumnIndex) => {
      return (
        <MovingColumnCards
          id={ColumnItem?._id}
          isProductArchived={isProductArchived}
          ColumnItem={ColumnItem}
          onSelectCheckBox={onSelectCheckBox}
          editState={editState}
          handleEdit={handleEdit}
          isName={isName}
          activeInactiveClicked={activeInactiveClicked}
          deleteColumn={deleteColumn}
          index={ColumnIndex}
          moveColumn={moveColumn}
        />
      );
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [editState?.Columns, editState?.selectedColumns],
  );

  return (
    <>
      <div className="mt-2">
        <div className="d-flex align-items-center mb-2 ">
          {t('OPERATIONAL_CP.COLUMN_SECTION.COLUMN')}
          {OperationalAddEditAccess && (
            <div className="btn-outline-container ml-1">
              <BtnAddWithoutToolTip onBtnClick={addColumn} forDisable={isProductArchived} addEditAccess />
            </div>
          )}
          {OperationalDeleteAccess && (
            <div className="btn-outline-container">
              <BtnDelete multiDelete={() => deleteColumn(null)} isDisabled={isEmpty(editState?.selectedColumns) || isProductArchived} />
            </div>
          )}
        </div>
        <div className="table-responsive">
          <table className="table xs-layout-fixed custom-table  m-0">
            <thead>
              <tr>
                {!isSupplierLoggedIn && (OperationalAddEditAccess || OperationalDeleteAccess) && (
                  <th className="w-80px w-xs-40px">
                    <div className="checkbox-label no-label margin-auto">
                      <input
                        type="checkbox"
                        onChange={handleSelectAllColumns}
                        name="check_all_column"
                        id="check_all_column"
                        checked={editState.selectAllColumns}
                        disabled={isEmpty(editState.Columns) || isName}
                      />
                      <label htmlFor="check_all_column" className="chklabel">
                        <span />
                      </label>
                    </div>
                  </th>
                )}
                <th className="w-400px w-xs-150px">
                  <span className="cursor-pointer">{t('OPERATIONAL_CP.COLUMN_SECTION.FIELD_NAME')}</span>
                </th>
                <th className="w-200px w-xs-150px">
                  <span className="cursor-pointer">{t('OPERATIONAL_CP.COLUMN_SECTION.TYPE')}</span>
                </th>
                {!isSupplierLoggedIn && (OperationalAddEditAccess || OperationalDeleteAccess) && (
                  <th className="w-150px">
                    <span className="cursor-pointer">{t('OPERATIONAL_CP.COLUMN_SECTION.ACTION')}</span>
                  </th>
                )}
              </tr>
            </thead>
            <tbody>
              <DndProvider backend={HTML5Backend}>
                {editState?.Columns && !isEmpty(editState?.Columns) ? (
                  editState?.Columns?.map((columnItem, columnIndex) => {
                    return <React.Fragment key={`${columnItem?._id}`}>{renderTableColumns(columnItem, columnIndex)}</React.Fragment>;
                  })
                ) : (
                  <tr>
                    <td className=" text-center" colSpan="100%">
                      <span>{t('OPERATIONAL_CP.COLUMN_SECTION.NO_COLUMN_ADDED')}</span>
                    </td>
                  </tr>
                )}
              </DndProvider>
            </tbody>
          </table>
        </div>
      </div>
      {editState.showColumnModal && (
        <AddEditColumn
          isProductArchived={isProductArchived}
          open={editState.showColumnModal}
          toggle={closeColumnModal}
          editData={editState.editColumnData}
          parentData={editState}
        />
      )}
    </>
  );
}

export default ColumnSection;
